"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RiskTargetsAppContent = void 0;
var React = require("react");
var riskTargetsContext_1 = require("../../context/admin/riskTargetsContext");
var buttons_1 = require("../buttons");
var generic_1 = require("../generic");
var typestyle_1 = require("typestyle");
var matrixUtils_1 = require("./matrixUtils");
var editMatrixDialogContext_1 = require("../../context/admin/editMatrixDialogContext");
var editMatrixDialog_1 = require("./editMatrixDialog");
var importRiskTargetsContext_1 = require("../../context/admin/importRiskTargetsContext");
var importRiskTargets_1 = require("./importRiskTargets");
var RiskTargetInfo = function (props) {
    return (React.createElement(riskTargetsContext_1.default.Consumer, null, function (context) {
        return React.createElement("div", { className: "RiskTargetInfo" },
            React.createElement("div", { className: "row mb-2" },
                React.createElement("div", { className: "col pt-2" }, gettext("Name")),
                React.createElement("div", { className: "col-lg-4 col-2 col-xs-3 float-right" },
                    React.createElement("div", { className: "row" },
                        React.createElement(buttons_1.ActionButton, { title: gettext("Copy Risk Target"), onClick: function () {
                                return fancyConfirm(gettext("Are you sure you want to make a copy" +
                                    " of the risk target:") + " " + props.riskTarget.name, function () {
                                    return context.duplicateRiskTarget(props.riskTarget);
                                });
                            } },
                            React.createElement(generic_1.Icon, { name: generic_1.Icons.copy })),
                        React.createElement(buttons_1.ActionButton, { onClick: function () {
                                return fancyConfirm(gettext("Do you really want to delete the risk target?"), function () { return context.deleteRiskTarget(props.riskTarget); });
                            } },
                            React.createElement(generic_1.Icon, { name: generic_1.Icons.delete }))))),
            React.createElement("input", { type: "text", className: "form-control mb-2", value: props.riskTarget.name, onChange: function (e) {
                    return context.onChangeRiskTarget(props.riskTarget, "name", e.currentTarget.value);
                } }),
            React.createElement("label", null, gettext("Description")),
            React.createElement("textarea", { className: "form-control mb-2", onChange: function (e) {
                    return context.onChangeRiskTarget(props.riskTarget, "description", e.currentTarget.value);
                } }, props.riskTarget.description),
            React.createElement("label", null, gettext("Unit")),
            React.createElement("input", { type: "text", className: "form-control mb-2", value: props.riskTarget.unit, onChange: function (e) {
                    return context.onChangeRiskTarget(props.riskTarget, "unit", e.currentTarget.value);
                } }),
            React.createElement(buttons_1.PrimaryButton, { className: "btn-block mt-3", onClick: function () { return context.onSaveRiskTarget(props.riskTarget); } }, gettext("Save")));
    }));
};
var RiskTargetMatrix = function (props) {
    return (React.createElement(riskTargetsContext_1.default.Consumer, null, function (context) {
        return React.createElement("div", { className: "table-responsive-md" },
            React.createElement("table", { className: (0, typestyle_1.classes)("Matrix", props.matrix.is_opportunity ? "Matrix__Opportunity" : "Matrix__Risk") },
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("th", { className: "Frequency__Column text-center" }, props.matrix.is_opportunity ?
                            gettext("Opportunity Matrix") :
                            gettext("Risk Matrix")),
                        props.matrix.consequences.map(function (consequence) {
                            return React.createElement("th", { className: "Consequence__Column" },
                                React.createElement("input", { type: "text", className: "form-control", value: consequence.name, onChange: function (e) {
                                        return context.onChangeMatrixConsequence(consequence, "name", e.currentTarget.value);
                                    } }),
                                React.createElement("input", { type: "text", className: "form-control", value: (0, matrixUtils_1.displayConsequence)(consequence, props.matrix.consequence_display), readOnly: props.matrix.consequence_display != matrixUtils_1.ConsequenceDisplayChoices.DESCRIPTION, onChange: function (e) {
                                        if (props.matrix.consequence_display == matrixUtils_1.ConsequenceDisplayChoices.DESCRIPTION) {
                                            context.onChangeMatrixConsequence(consequence, "description", e.currentTarget.value);
                                        }
                                    } }));
                        })),
                    props.matrix.frequencies.map(function (frequency) { return (React.createElement("tr", null,
                        React.createElement("td", { className: "Frequency__Column" },
                            React.createElement("input", { type: "text", className: "form-control", value: frequency.name, onChange: function (e) {
                                    return context.onChangeMatrixFrequency(frequency, "name", e.currentTarget.value);
                                } }),
                            React.createElement("input", { type: "text", className: "form-control", value: (0, matrixUtils_1.displayFrequency)(frequency, props.matrix.frequency_display), readOnly: props.matrix.frequency_display != matrixUtils_1.FrequencyDisplayChoices.DESCRIPTION, onChange: function (e) {
                                    return context.onChangeMatrixFrequency(frequency, "description", e.currentTarget.value);
                                } })),
                        props.matrix.cells
                            .filter(function (cell) { return cell.row == frequency.row; })
                            .map(function (cell) { return (React.createElement("td", { className: (0, typestyle_1.classes)("MatrixCell", matrixUtils_1.CellChoices.getColorDisplay(cell.color)), onClick: function () { return context.onClickCell(props.matrix, cell); } },
                            React.createElement("input", { className: "form-control", type: 'text', value: cell.value, onClick: function (e) { return e.stopPropagation(); }, onChange: function (e) {
                                    return context.onChangeMatrixCell(cell, "value", e.currentTarget.value);
                                } }))); }))); }))));
    }));
};
var RiskTargetMatrixContainer = function (props) {
    return (React.createElement(riskTargetsContext_1.default.Consumer, null, function (context) {
        return React.createElement(editMatrixDialogContext_1.default.Consumer, null, function (dialogContext) {
            return React.createElement("div", { className: "RiskTargetMatrixContainer" },
                React.createElement("div", { className: "MatrixHeader row" },
                    React.createElement("div", { className: "col" },
                        React.createElement("div", { className: "form-inline" },
                            React.createElement("div", { className: "form-group" },
                                React.createElement("label", { className: "pr-1" },
                                    gettext("Rows"),
                                    ":"),
                                React.createElement("input", { type: "number", max: matrixUtils_1.MATRIX_MAX_SIZE, style: { width: "50px" }, className: (0, typestyle_1.classes)("form-control", "form-control-sm", "EditMatrix__Rows"), value: props.matrix.rows, onChange: function (e) {
                                        return context.onChangeMatrix(props.matrix, "rows", parseInt(e.currentTarget.value));
                                    } })),
                            React.createElement("div", { className: "form-group ml-2" },
                                React.createElement("label", { className: "pr-1" },
                                    gettext("Columns"),
                                    ":"),
                                React.createElement("input", { type: "number", max: matrixUtils_1.MATRIX_MAX_SIZE, style: { width: "50px" }, className: (0, typestyle_1.classes)("form-control", "form-control-sm", "EditMatrix__Cols"), value: props.matrix.columns, onChange: function (e) {
                                        return context.onChangeMatrix(props.matrix, "columns", parseInt(e.currentTarget.value));
                                    } })),
                            React.createElement("div", { className: (0, typestyle_1.classes)(props.matrix.is_opportunity ? "Matrix__Opportunity" : "Matrix__Risk", "form-group", "ml-2") },
                                React.createElement(generic_1.ChoiceSelect, { choices: riskTargetsContext_1.cellColorChoices, value: props.matrix.is_opportunity ? context.selectedOppColor : context.selectedRiskColor, onChange: function (e) {
                                        return context.onChangeColorSelector(e.currentTarget.value, props.matrix.is_opportunity);
                                    }, className: (0, typestyle_1.classes)("form-control", "form-control-sm") })))),
                    React.createElement("div", { className: "col-3" },
                        React.createElement("div", { className: "form-group pull-right" },
                            React.createElement(buttons_1.ActionButton, { title: gettext("Edit classes"), onClick: function () {
                                    return dialogContext.openDialog(props.matrix, context.fetchRiskTargets);
                                } },
                                React.createElement(generic_1.Icon, { name: generic_1.Icons.edit })),
                            React.createElement(buttons_1.ActionButton, { onClick: function () {
                                    return fancyConfirm(gettext("Do you really want to delete the matrix?"), function () { return context.deleteMatrix(props.riskTarget, props.matrix); });
                                } },
                                React.createElement(generic_1.Icon, { name: generic_1.Icons.delete }))))),
                React.createElement(RiskTargetMatrix, { riskTarget: props.riskTarget, matrix: props.matrix }));
        });
    }));
};
var CreateMatrixPlaceHolder = function (props) {
    return (React.createElement(riskTargetsContext_1.default.Consumer, null, function (context) {
        return React.createElement("div", { className: "CreateMatrixPlaceholder" },
            React.createElement("div", { className: "CreateMatrixPlaceholder__Button" },
                React.createElement(buttons_1.ActionButton, { onClick: function () {
                        return context.createMatrix(props.riskTarget, props.is_opportunity);
                    } },
                    "+",
                    props.is_opportunity ?
                        gettext("Add opportunity matrix") :
                        gettext("Add risk matrix"))));
    }));
};
var RiskTargetList = function (props) {
    return (React.createElement(riskTargetsContext_1.default.Consumer, null, function (context) {
        return React.createElement("div", { className: "RiskTargetList" }, props.risk_targets.map(function (riskTarget) {
            var riskMatrix = matrixUtils_1.RiskTargetUtils.getRiskMatrix(riskTarget);
            var oppMatrix = matrixUtils_1.RiskTargetUtils.getOpportunityMatrix(riskTarget);
            return (React.createElement("div", { className: "RiskTargetListItem row mb-3", key: riskTarget.id },
                React.createElement("div", { className: "col-xxl-2 col-lg-3 col-md-12 RiskTargetInfoContainer" },
                    React.createElement(RiskTargetInfo, { riskTarget: riskTarget })),
                React.createElement("div", { className: "col" },
                    React.createElement("div", { className: "row ml-2 p-2" },
                        React.createElement("div", { className: "col-xxl-6 col-xl-12" }, riskMatrix ?
                            React.createElement(RiskTargetMatrixContainer, { riskTarget: riskTarget, matrix: riskMatrix })
                            :
                                React.createElement(CreateMatrixPlaceHolder, { riskTarget: riskTarget, is_opportunity: false })),
                        React.createElement("div", { className: "col-xxl-6 col-xl-12" }, oppMatrix ?
                            React.createElement(RiskTargetMatrixContainer, { riskTarget: riskTarget, matrix: oppMatrix })
                            :
                                React.createElement(CreateMatrixPlaceHolder, { riskTarget: riskTarget, is_opportunity: true }))))));
        }));
    }));
};
var RiskTargetsAppContent = (function (_super) {
    __extends(RiskTargetsAppContent, _super);
    function RiskTargetsAppContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RiskTargetsAppContent.prototype.componentDidMount = function () {
        this.context.fetchRiskTargets();
    };
    RiskTargetsAppContent.prototype.render = function () {
        return (React.createElement(riskTargetsContext_1.default.Consumer, null, function (context) {
            return React.createElement(importRiskTargetsContext_1.default.Consumer, null, function (importContext) {
                return React.createElement("div", { className: "RiskTargetsApp" },
                    React.createElement(buttons_1.ActionButton, { onClick: context.createRiskTarget },
                        React.createElement(generic_1.Icon, { name: generic_1.Icons.plus_circle }),
                        gettext("New Risk Target")),
                    React.createElement(buttons_1.ActionButton, { onClick: importContext.openDialog },
                        React.createElement(generic_1.Icon, { name: generic_1.Icons.copy }),
                        "\u00A0",
                        gettext("Copy from project")),
                    React.createElement(RiskTargetList, { risk_targets: context.risk_targets }),
                    React.createElement(editMatrixDialog_1.EditMatrixDialog, null),
                    React.createElement(importRiskTargets_1.ImportRiskTargetsDialog, { onSaveSuccess: function () { return context.fetchRiskTargets(); } }));
            });
        }));
    };
    RiskTargetsAppContent.contextType = riskTargetsContext_1.default;
    return RiskTargetsAppContent;
}(React.Component));
exports.RiskTargetsAppContent = RiskTargetsAppContent;
var RiskTargetsApp = function (props) {
    return (React.createElement(riskTargetsContext_1.RiskTargetsContextProvider, { project_id: props.project_id },
        React.createElement(editMatrixDialogContext_1.EditMatrixDialogContextProvider, { project_id: props.project_id },
            React.createElement(importRiskTargetsContext_1.ImportRiskTargetsContextProvider, { project_id: props.project_id },
                React.createElement(RiskTargetsAppContent, null)))));
};
exports.default = RiskTargetsApp;
